import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import { FutureServicesMovementForm } from '@/core/domain/reports/movements/futureServices/futureServices.types';
import { Form } from 'antd';
import { FormInstance } from 'antd/es/form/Form';

interface Props {
  form: FormInstance<FutureServicesMovementForm>;
}

const MovementUpcomingRevisionsForm = ({ form }: Props) => {
  return (
    <Form form={form} layout="vertical">
      <ReportSelectMonthFields form={form} />
    </Form>
  );
};
export default MovementUpcomingRevisionsForm;
